<template>
  <div class="prescription-detail" v-if="rxData">
    <!-- 处方状态 -->
    <div class="prescription-status" :class="getStatusClass()">
      <div class="status-content">
        <van-icon :name="getStatusIcon()" color="#fff" size="28" />
        <span class="status-text">{{ getStatusText() }}</span>
      </div>
      <div class="validity">
        {{ rxData.dealDesc }}
      </div>
    </div>

    <!-- 医院信息 -->
    <div class="hospital-info">
      <div class="hospital-name">{{ rxData.clinicName }}</div>
      <div class="prescription-type">{{ rxData.deptName }}</div>
    </div>

    <!-- 处方笺 -->
    <div class="prescription-content">
      <div class="prescription-title">电子处方笺</div>

      <!-- 患者信息 -->
      <div class="info-section patient-info">
        <div class="info-item">
          <span class="label">患者信息：</span>
          <span class="value">{{ rxData.patientInfo.name }}</span>
          <span class="gender">{{ rxData.patientInfo.sex === 1 ? '男' : '女' }}</span>
          <span class="age">{{ calculateAge(rxData.patientInfo.birthdate) }}岁</span>
        </div>
        <div class="info-item">
          <span class="label">就诊科室：</span>
          <span class="value">{{ rxData.deptName }}</span>
        </div>
        <div class="info-item">
          <span class="label">开方时间：</span>
          <span class="value">{{ rxData.rxCreateTime }}</span>
        </div>
        <div class="info-item">
          <span class="label">处方号：</span>
          <span class="value">{{ rxData.rxNo }}</span>
          <van-icon
            name="description"
            color="#1989fa"
            v-clipboard:copy="rxData.rxNo"
            v-clipboard:success="() => $toast('复制成功')"
          />
        </div>
      </div>

      <!-- 临床诊断 -->
      <div class="info-section diagnosis">
        <div class="section-title">临床诊断</div>
        <div class="diagnosis-content">
          <div v-for="(disease, index) in rxData.diseaseInfos" :key="index">
            {{ disease.diseaseName }}
          </div>
        </div>
      </div>

      <!-- 处方信息 -->
      <div class="info-section medicine-info">
        <div class="section-title">处方药品</div>
        <div v-for="(drug, index) in rxData.drugsInfos" :key="index" class="medicine-item">
          <div class="medicine-name">{{ drug.comName }}</div>
          <div class="medicine-spec">{{ drug.spec }} x{{ drug.count }}{{ drug.countUnit }}</div>
          <div class="medicine-usage">
            <van-icon name="clock-o" />
            <span>{{ drug.usage }}，{{ drug.frequency }}，{{ drug.instructions }}，{{ drug.days }}</span>
          </div>
        </div>
      </div>

      <!-- 医生信息 -->
      <div class="info-section doctor-info">
        <div class="doctor">
          <span class="label">医师：</span>
          <span class="value">{{ rxData.doctorName }}</span>
        </div>
        <div class="checker">
          <span class="label">审核：</span>
          <span class="value">{{ rxData.pharmacistName }}</span>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="bottom-buttons" v-if="false">
      <van-button plain type="primary" class="cart-btn" @click="goToCart">加入购物车</van-button>
      <van-button type="primary" class="buy-btn" @click="buyNow">立即购买</van-button>
    </div>

    <div @click="preview" class="rx-btn" v-if="rxData.rxId && rxData.status === '1'">处方<br />图片</div>
  </div>
</template>

<script>
import { NavBar, Icon, Button, ImagePreview } from 'vant';
import services from '@/service';

export default {
  name: 'mallPrescriptionDetail',
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Button.name]: Button
  },
  data() {
    return {
      rxUrl: '',
      rxData: null
    };
  },
  methods: {
    preview() {
      ImagePreview([this.rxData.rxUrl]);
    },
    onClickLeft() {
      this.$router.back();
    },
    async getRxInfo() {
      const res = await services.mall.rxInfo(this.$route.query.id);
      this.rxData = res.data;
    },
    goToCart() {
      this.$router.push('/mall/cart');
    },
    buyNow() {
      this.$router.push('/mall/buy');
    },
    // 添加计算年龄的方法
    calculateAge(birthdate) {
      if (!birthdate) return '';
      const birth = new Date(birthdate);
      const now = new Date();
      let age = now.getFullYear() - birth.getFullYear();
      const monthDiff = now.getMonth() - birth.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birth.getDate())) {
        age--;
      }
      return age;
    },
    // 获取状态图标
    getStatusIcon() {
      if (!this.rxData) return 'checked';
      switch (this.rxData.status) {
        case '1':
          return 'checked'; // 已开方
        case '99':
          return 'close'; // 医生拒绝
        default:
          return 'clock-o'; // 其他状态
      }
    },
    // 获取状态文案
    getStatusText() {
      if (!this.rxData) return '';
      switch (this.rxData.status) {
        case '1':
          return '已开方';
        case '99':
          return '医生拒绝开方';
        default:
          return this.rxData.statusView || '处理中';
      }
    },
    // 获取状态样式类
    getStatusClass() {
      if (!this.rxData) return '';
      switch (this.rxData.status) {
        case '1':
          return 'status-success'; // 已开方 - 绿色
        case '99':
          return 'status-rejected'; // 医生拒绝 - 红色
        default:
          return 'status-processing'; // 其他状态 - 蓝色
      }
    }
  },
  mounted() {
    this.getRxInfo();
  }
};
</script>

<style lang="scss" scoped>
.rx-img {
  width: 100%;
}
.prescription-detail {
  min-height: 100vh;
  background-color: #f5f7fa;
  padding-bottom: 80px;

  .custom-nav {
    background: transparent;

    :deep(.van-nav-bar__title) {
      color: #333;
      font-size: 18px;
      font-weight: 500;
    }

    :deep(.van-icon) {
      color: #333;
    }
  }

  .prescription-status {
    background: linear-gradient(135deg, #1989fa, #4bb0ff);
    padding: 24px 20px;
    margin-bottom: 16px;
    border-radius: 0 0 24px 24px;
    box-shadow: 0 4px 12px rgba(0, 189, 212, 0.1);
    text-align: center;
    color: #fff;

    // 已开方状态 - 绿色
    &.status-success {
      background: linear-gradient(135deg, #07c160, #38d9a9);
      box-shadow: 0 4px 12px rgba(7, 193, 96, 0.2);
    }

    // 医生拒绝状态 - 红色
    &.status-rejected {
      background: linear-gradient(135deg, #ee0a24, #ff6b6b);
      box-shadow: 0 4px 12px rgba(238, 10, 36, 0.2);
    }

    // 处理中状态 - 蓝色（默认）
    &.status-processing {
      background: linear-gradient(135deg, #1989fa, #4bb0ff);
      box-shadow: 0 4px 12px rgba(0, 189, 212, 0.1);
    }

    .status-content {
      @include flex(row);
      align-items: center;
      justify-content: center;
    }

    .status-text {
      font-size: 20px;
      margin-left: 10px;
      font-weight: 500;
      vertical-align: middle;
    }

    .validity {
      font-size: 14px;
      margin-top: 12px;

      .validity-note {
        font-size: 12px;
        opacity: 0.8;
        margin-left: 4px;
      }
    }
  }

  .hospital-info {
    background: #fff;
    padding: 20px;
    margin: 0 16px 16px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

    .hospital-name {
      font-size: 17px;
      font-weight: 500;
      color: #333;
    }

    .prescription-type {
      font-size: 14px;
      color: #666;
      margin-top: 6px;
    }
  }

  .prescription-content {
    background: #fff;
    padding: 24px 20px;
    margin: 0 16px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

    .prescription-title {
      text-align: center;
      font-size: 20px;
      font-weight: 500;
      color: #333;
      margin-bottom: 24px;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        width: 40px;
        height: 3px;
        background: $appcolor;
        border-radius: 2px;
      }
    }

    .info-section {
      margin-bottom: 24px;
      padding-bottom: 20px;
      border-bottom: 1px solid #eee;

      &:last-child {
        margin-bottom: 0;
        padding-bottom: 0;
        border-bottom: none;
      }
    }

    .section-title {
      font-size: 16px;
      font-weight: 500;
      color: #333;
      margin-bottom: 12px;
      display: flex;
      align-items: center;

      &::before {
        content: '';
        width: 3px;
        height: 16px;
        background: $appcolor;
        margin-right: 8px;
        border-radius: 2px;
      }
    }

    .info-item {
      margin-bottom: 10px;
      font-size: 14px;
      display: flex;
      align-items: center;

      &:last-child {
        margin-bottom: 0;
      }

      .label {
        color: #666;
        min-width: 80px;
      }

      .value {
        color: #333;
        margin-right: 12px;
      }

      .gender,
      .age {
        color: #666;
        margin-right: 12px;
      }
    }

    .diagnosis-content {
      color: #333;
      line-height: 1.6;
      padding: 12px 16px;
      background: #f8f9fa;
      border-radius: 8px;
    }

    .medicine-item {
      padding: 16px;
      background: #f8f9fa;
      border-radius: 8px;

      .medicine-name {
        font-weight: 500;
        color: #333;
        margin-bottom: 8px;
      }

      .medicine-spec {
        font-size: 14px;
        color: #666;
        margin-bottom: 8px;
      }

      .medicine-usage {
        font-size: 14px;
        color: #666;
        display: flex;
        align-items: center;

        .van-icon {
          margin-right: 6px;
          color: $appcolor;
        }
      }
    }

    .doctor-info {
      display: flex;
      justify-content: space-between;
      font-size: 14px;

      .label {
        color: #666;
      }

      .value {
        color: #333;
        font-weight: 500;
      }
    }
  }

  .bottom-buttons {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    padding: 12px 16px;
    background: #fff;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);

    .cart-btn {
      flex: 1;
      margin-right: 12px;
      border-color: $appcolor;
      color: $appcolor;
    }

    .buy-btn {
      flex: 1;
      background: $appcolor;
      border-color: $appcolor;
    }

    :deep(.van-button) {
      height: 44px;
      font-size: 16px;
      font-weight: 500;
      border-radius: 22px;
    }
  }
}

.rx-btn {
  position: fixed;
  right: 30px;
  bottom: 75px;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1976d2, #64b5f6);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 1.2;
  text-align: center;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
  z-index: 99;
  transition: all 0.3s ease;

  &:active {
    transform: scale(0.95);
  }
}
</style>
